import { useState } from 'react';
import { Link } from 'react-router-dom';
import { productApi, type Product } from '../../api/products';

export function ProductSearchPage() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<Product[]>([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  async function search(e: React.FormEvent) {
    e.preventDefault();
    if (!query.trim()) return;
    setLoading(true);
    try {
      const res = await productApi.search(query.trim());
      setResults(res.results ?? (res as unknown as Product[]));
      setCount(res.count ?? results.length);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/products" className="text-sm text-slate-600 hover:underline">← Products</Link>
      <h1 className="mt-4 text-2xl font-semibold">Product Search</h1>
      <form onSubmit={(e) => void search(e)} className="mt-6 flex gap-3">
        <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search by name, SKU, brand…" className="flex-1 rounded-lg border px-3 py-2" />
        <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Search</button>
      </form>
      {loading ? <p className="mt-6">Searching…</p> : (
        <>
          {count > 0 && <p className="mt-4 text-sm text-slate-500">{count} results</p>}
          <ul className="mt-4 space-y-3">
            {results.map((p) => (
              <li key={p.id} className="rounded-xl border bg-white p-4">
                <Link to={`/products/${p.id}`} className="font-medium hover:underline">{p.name}</Link>
                <p className="text-sm text-slate-500">{p.identity?.sku} · {p.status}</p>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
